var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetsContacts01 = function SvgAssetsContacts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "assets_contacts-01_svg2__a",
    x1: 15.67,
    x2: 185.27,
    y1: 173.48,
    y2: 70.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#assets_contacts-01_svg2__a",
    id: "assets_contacts-01_svg2__b",
    x1: 11.15,
    x2: 180.75,
    y1: 166.02,
    y2: 63.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#assets_contacts-01_svg2__a",
    id: "assets_contacts-01_svg2__c",
    x1: 16.73,
    x2: 186.33,
    y1: 175.25,
    y2: 72.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#assets_contacts-01_svg2__a",
    id: "assets_contacts-01_svg2__d",
    x1: -7.14,
    x2: 162.46,
    y1: 135.78,
    y2: 33.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#assets_contacts-01_svg2__a",
    id: "assets_contacts-01_svg2__e",
    x1: -4.49,
    x2: 165.11,
    y1: 140.16,
    y2: 37.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#assets_contacts-01_svg2__a",
    id: "assets_contacts-01_svg2__f",
    x1: 17.01,
    x2: 186.61,
    y1: 175.7,
    y2: 73.11
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m142.97 98.06 15.94-8.86v19.9l-15.94 8.81V98.05Zm-20.59 11.05V89.2l15.98 8.86v19.91zm2.45-23.81 15.82-8.8 15.86 8.82-15.82 8.79zm14.67-13.37-20.55 11.42c-.36.19-.64.48-.83.81-.01.02-.02.03-.03.05-.03.06-.06.13-.09.19-.01.02-.02.04-.02.05-.13.33-.19.69-.16 1.05v24.92c0 .82.46 1.59 1.18 2l20.43 11.35c.11.07.24.13.36.19.02 0 .04.01.06.02.07.03.14.05.22.07.02 0 .03 0 .05.02.07.01.15.03.23.04.1.01.19.02.29.02.41 0 .82-.09 1.18-.32.02-.01.03-.02.06-.03l20.4-11.34c.73-.41 1.18-1.18 1.18-2.01V85.31c0-.61-.23-1.14-.64-1.54v-.02h-.01s-.01 0-.01-.01c-.15-.15-.33-.29-.52-.4l-20.54-11.42c-.37-.18-.76-.27-1.14-.27s-.76.09-1.1.27",
    style: {
      fill: "url(#assets_contacts-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.36 125.66a2.29 2.29 0 1 0 0 4.58h45.46a2.29 2.29 0 1 0 0-4.58z",
    style: {
      fill: "url(#assets_contacts-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.36 138.27c-1.26 0-2.29 1.02-2.29 2.28s1.03 2.29 2.29 2.29h45.46c1.26 0 2.29-1.02 2.29-2.29s-1.02-2.28-2.29-2.28z",
    style: {
      fill: "url(#assets_contacts-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.11 95.88c6.38 1.81 11.5 6.46 14.03 12.68-.63 1.34-2.05 2.36-3.71 2.36H57.81c-1.65 0-3-.95-3.7-2.36a21.8 21.8 0 0 1 14.02-12.68c1.81 1.02 3.86 1.57 5.99 1.57s4.25-.55 5.99-1.57M66.24 85.01c0-4.33 3.55-7.88 7.88-7.88S82 80.67 82 85.01s-3.54 7.88-7.88 7.88-7.88-3.54-7.88-7.88m-8.42-27.34c-4.81 0-8.75 3.94-8.75 8.75v2.05c0 1.26 1.03 2.28 2.29 2.28s2.28-1.02 2.28-2.28v-2.05c0-2.29 1.81-4.1 4.1-4.1h32.62c2.28 0 4.09 1.81 4.09 4.1v33.88a26.9 26.9 0 0 0-10.4-7.8c1.58-2.05 2.52-4.65 2.52-7.48 0-6.93-5.6-12.53-12.53-12.53s-12.53 5.6-12.53 12.53.94 5.36 2.52 7.48c-4.09 1.66-7.64 4.41-10.4 7.8V79.19c0-1.26-1.02-2.28-2.28-2.28s-2.29 1.02-2.29 2.28v27.66c0 4.81 3.94 8.74 8.75 8.74h32.62c4.81 0 8.75-3.94 8.75-8.74v-40.5.08c0-4.81-3.94-8.75-8.75-8.75H57.81Z",
    style: {
      fill: "url(#assets_contacts-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02 147.51c0-1.5 1.23-2.73 2.73-2.73h10.08c1.5 0 2.73 1.23 2.73 2.73s-1.23 2.73-2.73 2.73H6.75a2.74 2.74 0 0 1-2.73-2.73m0-23.57c0-1.5 1.23-2.73 2.73-2.73h10.08c1.5 0 2.73 1.23 2.73 2.73s-1.23 2.73-2.73 2.73H6.75a2.74 2.74 0 0 1-2.73-2.73m0-23.63c0-1.5 1.23-2.73 2.73-2.73h10.08c1.5 0 2.73 1.23 2.73 2.73s-1.23 2.73-2.73 2.73H6.75a2.74 2.74 0 0 1-2.73-2.73m0-23.65c0-1.5 1.23-2.73 2.73-2.73h10.08c1.5 0 2.73 1.23 2.73 2.73s-1.23 2.73-2.73 2.73H6.75a2.74 2.74 0 0 1-2.73-2.73m0-23.57c0-1.5 1.23-2.73 2.73-2.73h10.08c1.5 0 2.73 1.23 2.73 2.73s-1.23 2.72-2.73 2.72H6.75c-1.5 0-2.73-1.23-2.73-2.72m9.74-13.48c0-2.04 1.63-3.68 3.68-3.68h12.74v128.48H17.44c-2.04 0-3.68-1.63-3.68-3.68v-6.54h3.06c3.75 0 6.75-3 6.75-6.75s-3-6.75-6.75-6.75h-3.06v-10.15h3.06c3.75 0 6.75-2.99 6.75-6.74s-3-6.74-6.75-6.74h-3.06v-10.15h3.06c3.75 0 6.75-3 6.75-6.74s-3-6.74-6.75-6.74h-3.06V83.28h3.06c3.75 0 6.75-3 6.75-6.75s-3-6.75-6.75-6.75h-3.06V59.63h3.06c3.75 0 6.75-3 6.75-6.74s-3-6.74-6.75-6.74h-3.06zm3.68-7.43c-4.22 0-7.63 3.4-7.63 7.63v6.54H6.75C3 46.35 0 49.35 0 53.1s3 6.74 6.75 6.74h3.06v10.15H6.75C3 69.99 0 72.99 0 76.74s3 6.74 6.75 6.74h3.06v10.15H6.75C3 93.63 0 96.62 0 100.37s3 6.75 6.75 6.75h3.06v10.15H6.75c-3.75 0-6.75 3-6.75 6.75s3 6.75 6.75 6.75h3.06v10.15H6.75C3 140.92 0 143.91 0 147.66s3 6.75 6.75 6.75h3.06v6.54c0 4.22 3.41 7.63 7.63 7.63h87.68c4.22 0 7.63-3.41 7.63-7.63v-8.58c0-1.09-.89-1.98-1.98-1.98s-1.98.89-1.98 1.98v8.58c0 2.04-1.63 3.68-3.68 3.68H34.13V36.2h70.98c2.04 0 3.68 1.63 3.68 3.68v103c0 1.09.89 1.98 1.98 1.98s1.98-.89 1.98-1.98V39.81c0-4.22-3.41-7.63-7.63-7.63z",
    style: {
      fill: "url(#assets_contacts-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.79 159.75v-8.54l6.85-3.79 6.85 3.84v8.49l-6.85 3.79zm47.95-27.04v-8.49l6.85-3.75 6.85 3.79v8.45l-6.85 3.79zm0-59.36v-8.49l6.85-3.79 6.85 3.79v8.49l-6.85 3.79zm-47.95-24.7V40.1l6.85-3.79 6.85 3.79v8.55l-6.85 3.79zm6.86-17.21c-.38 0-.76.09-1.1.27l-9.13 5.07c-.73.41-1.18 1.18-1.18 2v8.97l-12.97 7.21v5.2l14.45-8.03 7.66 4.25v9.28c0 1.28 1 2.28 2.28 2.28s2.28-1.01 2.28-2.28V56.4l7.7-4.27 26.56 14.74v6.49l-10.32 6.5c-1.09.68-1.42 2.1-.73 3.15.41.68 1.14 1.05 1.92 1.05.41 0 .82-.14 1.23-.32l10.23-6.44 6.8 3.78v35.38l-6.87 3.81v.03l-10.21-6.43c-1.05-.64-2.47-.32-3.15.73-.64 1.05-.32 2.47.74 3.15l10.36 6.54v8.66l-26.58 14.77-7.67-4.26v-13.83c0-1.28-1.01-2.28-2.28-2.28s-2.28 1.01-2.28 2.28v13.86l-7.7 4.27-14.41-8v5.21l12.97 7.2v8.93c0 .82.46 1.59 1.18 2.01l9.13 5.07c.32.18.74.28 1.1.28s.77-.09 1.14-.28l9.13-5.07c.74-.41 1.18-1.18 1.18-2.01v-8.99l27.55-15.31 7.84 4.35c.32.18.73.27 1.09.27s.78-.09 1.1-.27l9.13-5.07a2.32 2.32 0 0 0 1.18-2.01v-11.14c0-.82-.46-1.6-1.14-2.01l-7.99-4.44V81.12l7.94-4.41c.73-.41 1.18-1.18 1.18-2.01V63.56c0-.82-.46-1.59-1.14-2.01l-9.13-5.07c-.73-.36-1.55-.36-2.24 0l-9.13 5.07c-.22.12-.42.29-.58.47l-25.68-14.26v-8.95c0-.83-.46-1.6-1.18-2.01l-9.13-5.07c-.37-.18-.75-.27-1.13-.27Z",
    style: {
      fill: "url(#assets_contacts-01_svg2__f)"
    }
  }));
};
export default SvgAssetsContacts01;